import { EventEmitter } from 'utils/event-emitter';

export const TimerEvEm = new EventEmitter<'start' | 'pause'>();
